
export default (uuid) => {
  return uuid.slice(-8)
}
